import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { get } from "http";

@Injectable({
  providedIn: 'root',
})
export class TranslationsService {

  public accountName = 'core';
  public bucket = 'pro-vw-private-common-resources.staticresources.3ddvapis.com';

  private translations: JSON;

  constructor(
    private http: HttpClient
  ) {}

  public getTranslations(): JSON {
    return this.translations;
  }
  public setTranslations(data: JSON): void {
    this.translations = data;
  }

}